// 10 Curated Recipe Clubs for ShareRecipe Public Access
import club1 from "../assets/comida_1.svg";
import club2 from "../assets/comida_2.svg";
import club3 from "../assets/comida_3.svg";
import club4 from "../assets/comida_4.svg";
import heroImg from "../assets/Illustration.svg";
import serviceImg from "../assets/bloco_services.svg";

export const CLUBS_DATA = [
  {
    id: "gourmet-chefs-club",
    name: "Gourmet Chefs Club",
    slogan: "Elevate your home dining with master techniques",
    description: "Join top home chefs and culinary enthusiasts sharing secret fine-dining recipes, plating techniques, and restaurant-quality dishes.",
    membersCount: "1,240",
    tags: ["Fine Dining", "Italian", "French", "Gourmet"],
    image: club1,
    host: "Chef Antonio Rossi",
    rating: 4.9,
    featuredRecipes: ["Broccoli Salad With Bacon", "Creamy Tuscan Garlic Chicken"]
  },
  {
    id: "healthy-vegans",
    name: "Healthy Vegans & Plant-Based",
    slogan: "Nourish your body with vibrant plant power",
    description: "A warm community dedicated to 100% plant-based recipes, high-protein vegan meals, fresh grain bowls, and nutrient-dense smoothies.",
    membersCount: "3,850",
    tags: ["Vegan", "Organic", "Plant-Based", "Gluten-Free"],
    image: club2,
    host: "Maya Lin",
    rating: 4.8,
    featuredRecipes: ["Berry Acai Smoothie Bowl", "Avocado Toast Supreme"]
  },
  {
    id: "mediterranean-delights",
    name: "Mediterranean Delights",
    slogan: "Fresh, wholesome & sun-drenched coastal flavors",
    description: "Discover heart-healthy olive oil dishes, grilled seafood, fresh herbs, and wholesome Mediterranean dietary favorites.",
    membersCount: "2,190",
    tags: ["Mediterranean", "Seafood", "Olive Oil", "Healthy"],
    image: club3,
    host: "Elena Vasquez",
    rating: 4.9,
    featuredRecipes: ["Classic Potato Salad", "Greek Feta Bowl"]
  },
  {
    id: "quick-15min-meals",
    name: "Quick 15-Minute Meals",
    slogan: "Delicious, stress-free cooking for busy lives",
    description: "Fast, flavorful recipes designed to get dinner on the table in 15 minutes or less without compromising on taste or quality.",
    membersCount: "5,420",
    tags: ["Quick", "Easy", "15-Min", "Budget-Friendly"],
    image: club4,
    host: "Sarah Jenkins",
    rating: 4.7,
    featuredRecipes: ["Classic Beef Burgers", "Pan-Seared Salmon"]
  },
  {
    id: "artisanal-baking-desserts",
    name: "Artisanal Baking & Desserts",
    slogan: "Sweet treats and sourdough baking secrets",
    description: "Master sourdough starters, decadent chocolate cakes, fruit cobblers, and golden pastries with fellow passionate bakers.",
    membersCount: "4,110",
    tags: ["Baking", "Desserts", "Sourdough", "Pastry"],
    image: club1,
    host: "Baker Thomas",
    rating: 4.9,
    featuredRecipes: ["Cherry Cobbler on the Grill", "Sourdough Artisan Loaf"]
  },
  {
    id: "asian-street-food",
    name: "Asian Street Food Explorers",
    slogan: "Authentic ramen, dim sum, curries & stir-fries",
    description: "Explore the rich street food cultures of Japan, Thailand, Vietnam, and Korea with easy-to-follow home recipes.",
    membersCount: "2,980",
    tags: ["Asian", "Ramen", "Spicy", "Street Food"],
    image: club2,
    host: "Kenji Takahashi",
    rating: 4.8,
    featuredRecipes: ["Authentic Thai Green Curry", "Crispy Gyoza"]
  },
  {
    id: "bbq-grill-masters",
    name: "BBQ & Grill Masters",
    slogan: "Smoky rubs, slow barbecue & flame-grilled perfection",
    description: "Fire up the grill! Exchange marinades, smoking tips, grilled sides, and barbecue secrets for year-round outdoor cooking.",
    membersCount: "1,860",
    tags: ["BBQ", "Grill", "Smoked", "Meats"],
    image: club3,
    host: "Dave 'Smokey' Smith",
    rating: 4.8,
    featuredRecipes: ["Cherry Cobbler on the Grill", "Smoked Beef Brisket"]
  },
  {
    id: "keto-fitness-mealprep",
    name: "Keto & Fitness Meal Prep",
    slogan: "Fuel your fitness goals with macro-counted meals",
    description: "Low-carb recipes, macro breakdown guides, and weekly batch meal prepping for bodybuilders and health-conscious athletes.",
    membersCount: "3,300",
    tags: ["Keto", "Low Carb", "Fitness", "Meal Prep"],
    image: club4,
    host: "Dr. Marcus Vance",
    rating: 4.7,
    featuredRecipes: ["Broccoli Salad With Bacon", "Keto Cauliflower Rice"]
  },
  {
    id: "comfort-food-classics",
    name: "Comfort Food Classics",
    slogan: "Hearty, soul-warming recipes loved by families",
    description: "Classic casseroles, creamy pastas, homemade soups, and traditional family favorite recipes handed down through generations.",
    membersCount: "2,450",
    tags: ["Comfort Food", "Pasta", "Family", "Classic"],
    image: heroImg,
    host: "Grandma Clara",
    rating: 4.9,
    featuredRecipes: ["Classic Beef Burgers", "Creamy Mushroom Risotto"]
  },
  {
    id: "smoothie-breakfast-club",
    name: "Smoothie & Morning Club",
    slogan: "Start every morning energized & refreshed",
    description: "Energizing breakfast bowls, cold-pressed juices, chia seed puddings, and quick morning coffee treats.",
    membersCount: "1,940",
    tags: ["Breakfast", "Smoothies", "Morning", "Juices"],
    image: serviceImg,
    host: "Chloe Adams",
    rating: 4.8,
    featuredRecipes: ["Berry Acai Smoothie Bowl", "Avocado Toast Supreme"]
  }
];
